import { render } from "./empty.html?vue&type=template&id=9e883ff2"
import script from "./emptyStatus-center.vue?vue&type=script&lang=js"
export * from "./emptyStatus-center.vue?vue&type=script&lang=js"

import "./empty.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/search-result/_components/emptyStatus-center.vue'],['render',render],['__file',"emptyStatus-center.vue"]])

export default __exports__